import { Typography } from "@mui/material";
import { ReactElement, ReactNode } from "react";

import { palette } from "~frontend/theme";

import { FlexBox } from "../FlexBox";
import Loading from "../Loading";
import { AnalyticsDashboardSection } from "./AnalyticsDashboardSection";
import { DataContainer, EmptyDataContainer } from "./DataContainer";

export function ChartContainer({
  title,
  loading,
  children,
  downloadableRows,
  downloadFileName,
  empty,
}: {
  title: string;
  loading: boolean;
  children: ReactNode;
  downloadableRows?: Record<string, string>[];
  downloadFileName?: string;
  empty?: boolean;
}): ReactElement {
  return (
    <AnalyticsDashboardSection
      title={title}
      downloadDisabled={loading}
      downloadableRows={downloadableRows}
      downloadFileName={downloadFileName}
    >
      {empty ? (
        <EmptyDataContainer
          sx={{
            width: "100%",
            height: "318px",
          }}
        >
          <FlexBox
            sx={{ width: "100%", height: "100%", color: palette.darkGray }}
            alignItems="center"
            justifyContent="space-around"
          >
            <Typography variant="body2">No available data</Typography>
          </FlexBox>
        </EmptyDataContainer>
      ) : (
        <DataContainer
          sx={{
            width: "100%",
            height: "318px",
          }}
        >
          {loading ? (
            <FlexBox
              sx={{ width: "100%", height: "100%" }}
              alignItems="center"
              justifyContent="space-around"
            >
              <Loading />
            </FlexBox>
          ) : (
            children
          )}
        </DataContainer>
      )}
    </AnalyticsDashboardSection>
  );
}
